import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';
import PlayerXP from './PlayerXP';
import PlayerLevel from './PlayerLevel';
import PlayerStars from './PlayerStars';


const PlayerProgress = ({level, xp, startLevelBar, percentageLevelBar, endLevelBar, goldStars, blueStars, accountId}) => {
    return (
        <div className="playerProgress">
            <PlayerXP level={level} xp={xp} />
            <PlayerLevel startLevelBar={startLevelBar} percentageLevelBar={percentageLevelBar} endLevelBar={endLevelBar} />
            <PlayerStars goldStars={goldStars} blueStars={blueStars} />
            <div className="rankRow">
                <div className="statColumn"><Message code="epic.ut.stats.ID" /></div>
                <div className="xpDataColumn">{accountId}</div>
            </div>
        </div>
    )
}

PlayerProgress.propTypes = {
    level: PropTypes.number,
    xp: PropTypes.number,
    startLevelBar: PropTypes.number,
    percentageLevelBar: PropTypes.number,
    endLevelBar: PropTypes.number,
    goldStars: PropTypes.number,
    blueStars: PropTypes.number,
    accountId: PropTypes.string
}

export default PlayerProgress
